module.exports = __webpack_public_path__ + "static/media/visuals1.2e945bb4.mp3";